import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

import { isColorSchemeLight } from "Utilities/Colors/isColorSchemeLight";

ManageMyGivingPageColors.propTypes = {
  children: PropTypes.object,
};

export default function ManageMyGivingPageColors({ children }) {
  const { state, dispatch } = useManageMyGivingPage();
  const [isLight, setIsLight] = useState(null);

  useEffect(
    function setContextValue() {
      const colorScheme = state.pageSettings.colorScheme;
      const result = isColorSchemeLight(colorScheme);

      dispatch({
        type: "setColorSchemeIsLight",
        payload: result,
      });
      setIsLight(result);
    },
    [state.pageSettings.colorScheme, dispatch]
  );

  return (
    <div
      style={{
        "--textPrimary": isLight ? "#383838" : "#EFEFEF",
        "--textInverse": isLight ? "#EFEFEF" : "#383838",
        "--bgGradient1": isLight
          ? "rgba(0, 0, 0, 0.35)"
          : "rgba(0, 0, 0, 0.25)",
        "--bgGradient2": isLight ? "rgba(0, 0, 0, 0.55)" : "rgba(0, 0, 0, 0.4)",
      }}
    >
      {children}
    </div>
  );
}
